import { useMutation } from 'react-query';
import editRoomComment from '../requests/editRoomComment';

const useEditRoomCommentMutation = (options) =>
  useMutation(
    ({ comment, room }) => editRoomComment(comment, room),
    options
  );

export default useEditRoomCommentMutation;
